import type { ReactNode } from "react";

import type { FrostFreeSource, HeatingNetworkFrostFreeSource, RoomFrostFreeSource } from "./status.helper";

/** Wraps the alert with a navigation target, or `null` when the viewer cannot reach that setting. */
type FrostFreeSlot = ((alert: ReactNode) => ReactNode) | null;

type FrostFreeSlots<TSource extends FrostFreeSource> = Record<TSource, FrostFreeSlot>;

type HeatingNetworkFrostFreeSlots = FrostFreeSlots<HeatingNetworkFrostFreeSource>;
type RoomFrostFreeSlots = FrostFreeSlots<RoomFrostFreeSource>;

export const applySlot = <TSource extends FrostFreeSource>(
  source: TSource,
  alert: ReactNode,
  slots: FrostFreeSlots<TSource>,
): ReactNode => slots[source]?.(alert) ?? alert;

export type { FrostFreeSlot, FrostFreeSlots, HeatingNetworkFrostFreeSlots, RoomFrostFreeSlots };
